import { z } from 'zod';

export const projectSchema = z.object({
  name: z.string().min(2, 'Project name must be at least 2 characters'),
  description: z.string().optional(),
  start_date: z.string(),
  end_date: z.string().refine(date => new Date(date) >= new Date(new Date().setHours(0, 0, 0, 0)), {
    message: 'End date must not be in the past'
  }),
  priority: z.enum(['low', 'medium', 'high']).default('medium'),
  owner_id: z.string().uuid().optional(),
  template_id: z.string().uuid().optional()
}).refine((data) => {
  const startDate = new Date(data.start_date);
  const endDate = new Date(data.end_date);
  return endDate >= startDate;
}, {
  message: "End date must be after start date",
  path: ["end_date"]
});

export type ProjectFormData = z.infer<typeof projectSchema>;